import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    '&': {
      '@global': {
        label: {
          fontSize: 12,
          fontWeight: 'bold'
        }
      }
    }
  },
  saveButton: {
    display: 'inline',
    position: 'relative'
  },
  saveAsNewButton: {
    display: 'inline',
    position: 'relative',
    marginRight: `${theme.spacing(2)}px !important`
  },
  approveButton: {
    display: 'inline',
    position: 'relative'
  },
  headerButtons: {
    marginRight: `${theme.spacing(2)}px !important`
  },
  additionalIcon: {
    marginRight: theme.spacing(1)
  }
}))

export {
  useStyles
}
